import React from 'react';
import { Link } from '@chakra-ui/react';

import { ArcButton } from '../../common/components/ArcButton';

export const CallSupportButton = () => {
  return (
    <ArcButton arcColor="#FF5B44" w={'90%'} mx="auto" mt={6} minW={300}>
      <Link data-testid={'notification-support-phone'} isExternal href={'tel:+18777346631'} fontSize="sm">
        Call: 1-877-SE-MONITOR 1 (+1-877-734-6631)
      </Link>
    </ArcButton>
  );
};
